import { CardContent, Grid, Typography, Stack } from '@mui/material'
import {
  useTranslate,
  useShowContext,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  useLocaleState,
  // BooleanField,
} from 'react-admin'
import { ShowBase } from '../../components/base'
import { BOOKINGVIEW_FIELDS, TEMPORARYREQUEST_FIELDS } from '../../providers/localization/constant'
import Timeline from '@mui/lab/Timeline'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent'
import TimelineDot from '@mui/lab/TimelineDot'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import {
  ContentWrapper,
  Heading,
  TextFieldStyled,
  // EmailFieldStyled,
  DateFieldStyled,
  SelectFieldStyled,
  // NumberFieldStyled,
  BookingTimeField,
} from '../../components/domains/bookings'
// import moment from 'moment'
import CreateIcon from '@mui/icons-material/Create';
import PushPinIcon from '@mui/icons-material/PushPin';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';


dayjs.extend(isSameOrBefore)

const DefaultTimeline = ({ record }): JSX.Element => {
  const date = dayjs(record.create_at)
  // const date = moment(record.create_at, 'HH:mm')
  // console.log('🚀 ~ file: Show.tsx:40 ~ DefaultTimeline ~ record.create_at:', record.create_at)
  // console.log('🚀 ~ file: Show.tsx:40 ~ DefaultTimeline ~ date:', date)
  const [activeLocale] = useLocaleState()
  // const format = 'DD/MM/YYYY, HH:mm:ss a'
  return (
    <TimelineItem key={0}>
      <TimelineOppositeContent
        sx={{ m: 'auto 0' }}
        align='left'
        variant='body2'
        color='text.secondary'
      >
        {activeLocale === 'th'
          ? date.add(543, 'year').locale('th').format('DD/MM/YYYY, HH:mm:ss น.')
          : date.subtract(7, 'hour').format('HH:mm')}
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineConnector />
        <TimelineDot color={'primary'}>
          <CreateIcon />
        </TimelineDot>
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent sx={{ py: '12px', px: 2 }}>
        <Typography variant='h6' component='span'>
          สร้าง
        </Typography>
        <Typography>
          {' '}
          {record.status_history.status == 'cancel'
            ? record.id
            : record.status_history.cancel_reason}
        </Typography>
      </TimelineContent>
    </TimelineItem>
  )
}

const BookingDetail = (): JSX.Element => {
  const { record, error, isLoading } = useShowContext()
  const translate = useTranslate()
  const [locale] = useLocaleState()
  // const isCancelled = record.status === 'cancel';
  return (
    <Grid container spacing={3} sx={{ padding: '16px 16px 0' }}>
      {!isLoading && (
        <>
          <Grid item xs={12} md={12}>
            <Stack spacing={1}>
              <Typography variant='h4' sx={{ color: '#000000' }}>
                {record.subject}
              </Typography>
            </Stack>
          </Grid>
          <Grid item sm={12} md={6}>
            <Stack spacing={2}>
              {/* <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.subject`)}</Heading>
                  <TextFieldStyled source='subject' emptyText='-' />
                </ContentWrapper>
              </Grid> */}
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.status.label`)}</Heading>
                  <SelectFieldStyled
                    source='status'
                    emptyText='-'
                    choices={[
                      { id: 'pending', name: `${BOOKINGVIEW_FIELDS}.status.choices.pending` },
                      { id: 'confirm', name: `${BOOKINGVIEW_FIELDS}.status.choices.confirm` },
                      { id: 'cancel', name: `${BOOKINGVIEW_FIELDS}.status.choices.cancel` },
                      { id: 'reserve', name: `${BOOKINGVIEW_FIELDS}.status.choices.reserve` },
                      { id: 'complete', name: `${BOOKINGVIEW_FIELDS}.status.choices.complete` },
                      {
                        id: 'temporary_request',
                        name: `${BOOKINGVIEW_FIELDS}.status.choices.temporary_request`,
                      },
                    ]}
                  />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.book_id`)}</Heading>
                  <TextFieldStyled source='book_id' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.branch_code`)}</Heading>
                  <TextFieldStyled source='branch_code' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.booking_slot`)}</Heading>
                  <TextFieldStyled source='booking_slot' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.booking_date`)}</Heading>
                  <DateFieldStyled source='booking_date' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${TEMPORARYREQUEST_FIELDS}.service`)}</Heading>
                  <ReferenceArrayField reference='services' source='selected_services_keys_id'>
                    <SingleFieldList linkType={false}>
                      <ChipField source={`title_${locale}`} />
                    </SingleFieldList>
                  </ReferenceArrayField>
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.start_time`)}</Heading>
                  <BookingTimeField source='booking_start_time' emptyText='-' showTime={true} />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.end_time`)}</Heading>
                  <BookingTimeField source='booking_end_time' emptyText='-' showTime={true} />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.create_at`)}</Heading>
                  <DateFieldStyled source='create_at' emptyText='-' />
                </ContentWrapper>
              </Grid>
            </Stack>
          </Grid>
          <Grid item sm={12} md={6}>
            <Stack spacing={2}>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.first_name`)}</Heading>
                  <TextFieldStyled source='first_name' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.last_name`)}</Heading>
                  <TextFieldStyled source='last_name' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.email`)}</Heading>
                  <TextFieldStyled source='email' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.tel`)}</Heading>
                  <TextFieldStyled source='tel' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.license_plate`)}</Heading>
                  <TextFieldStyled source='license_plate' emptyText='-' />{' '}
                  <TextFieldStyled source='license_plate_province' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.more_detail`)}</Heading>
                  <TextFieldStyled source='more_detail' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.car_brand`)}</Heading>
                  <TextFieldStyled source='car_brand' emptyText='-' />
                </ContentWrapper>
              </Grid>
              <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.car_model`)}</Heading>
                  <TextFieldStyled source='car_model' emptyText='-' />
                </ContentWrapper>
              </Grid>
              {/* <Grid item>
                <ContentWrapper>
                  <Heading>{translate(`${BOOKINGVIEW_FIELDS}.accept`)}</Heading>
                  <BooleanField
                    source='is_accept'
                    label={`${BOOKINGVIEW_FIELDS}.is_accept`}
                  />
                </ContentWrapper>
              </Grid> */}
            </Stack>
          </Grid>
        </>
      )}
      {isLoading && (
        <Grid container>
          <Grid item xs={12} justifyContent='center'>
            <Typography>Loading...</Typography>
          </Grid>
        </Grid>
      )}
      {error && (
        <Grid container>
          <Grid item xs={12} justifyContent='center'>
            <Typography>Error cannot load resource, please contact admin</Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

const CRMLogList = (): JSX.Element => {
  const { record, isLoading } = useShowContext()
  const [activeLocale] = useLocaleState()
  if (isLoading) return null
  const format = 'DD/MM/YYYY, HH:mm:ss a'
  const statusTH = [
    { id: 'pending', name: 'รอดำเนินการ' },
    { id: 'confirm', name: 'ยืนยันนัดหมาย' },
    { id: 'cancel', name: 'ยกเลิก' },
    { id: 'reserve', name: 'จอง' },
    { id: 'complete', name: 'เสร็จสิ้น' },
    {
      id: 'temporary_request',
      name: 'ขอคิวสำรอง',
    },
  ]
  return (
    <Grid>
      <Grid container>
        <Grid item xs={12}>
          <Stack spacing={1}>
            <Typography variant='h4' sx={{ color: '#000000' }}>
              ประวัติสถานะ
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Timeline position='alternate'>
            <DefaultTimeline record={record} />
            {record.status_history?.map((log, i) => {
              const date = dayjs(log.timestamp)
              return (
                <TimelineItem key={i}>
                  <TimelineOppositeContent
                    sx={{ m: 'auto 0' }}
                    align={i % 2 != 0 ? 'right' : 'left'}
                    variant='body2'
                    color='text.secondary'
                  >
                    {activeLocale === 'th'
                      ? date.add(543, 'year').locale('th').add(7, 'hours').format('DD/MM/YYYY, HH:mm:ss น.')
                      : date.format(format)}
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineConnector />
                    <TimelineDot color={log.status == 'cancel' ? 'error' : log.status == 'complete' ? 'success' : 'primary'}>
                      {log.status == 'cancel' ? <PriorityHighIcon /> : log.status == 'complete' ? <EventAvailableIcon style={{color: '#FFFFFF'}}/> : <PushPinIcon />}
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: '12px', px: 2 }}>
                    <Typography variant='h6' component='span'>
                      {statusTH.find((status) => status.id === log.status)?.name || ''}
                    </Typography>
                    <Typography>{log.cancel_reason}</Typography>
                  </TimelineContent>
                </TimelineItem>
              )
            })}
          </Timeline>
        </Grid>
      </Grid>
    </Grid>
  )
}

const BookingShow = (): JSX.Element => {
  return (
    <ShowBase
      title='resources.bookingview.fields.show.title'
      listAction={{ hasEdit: false, hasBackButton: true }}
    >
      <>
        <CardContent>
          <BookingDetail />
        </CardContent>
        <CardContent>
          <CRMLogList />
        </CardContent>
      </>
    </ShowBase>
  )
}

export default BookingShow
